import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MeetingHolidayResponse } from '../models/meeting.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface HolidayDrawerOptions {
  holidayId?: number;
}

@Injectable({ providedIn: 'root' })
export class MeetingHolidayDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: HolidayDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly saved$$ = new Subject<MeetingHolidayResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: HolidayDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: MeetingHolidayResponse): void {
    this.saved$$.next(item);
  }
}
